// extracted by mini-css-extract-plugin
export default {"main":"Button_main__eyq-m","reverse":"Button_reverse__9BWAV"};